import React from "react";
import "./WhiteButton.css";

export default function WhiteButton({
  title,
  onClick,
  disabled = false,
  bg = "yellow",
  color = "#000000",
  hoverBg,
  hoverColor,
  className = "",
type="button"
}) 

{

  
  return (
    <button
      type={type}
      className={`white-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        "--btn-bg": bg,
        "--btn-color": color,
        "--btn-hover-bg": hoverBg,
        "--btn-hover-color": hoverColor,
      }}
    >
      {title}
    </button>
  );
}
